import request from "../utils/request";

/**
 * 获取微信分享配置信息
 * @param {*} from 
 * @returns 
 */
export function getSignature(from) {
    return request.post('/wechat/signature', from);
}